/*
 * 数据字典管理接口
 * */
import services from "../config/axios";
import base from './base';
// 定义参数类型
type paramsType<T> = {
    [key: string]: T;
};

const digitalDictManageAPI = {
    // 获取总部
    getHeadquarterList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetHeadquarterList`, params);
    },
    // 获取总部one
    getHeadquarterOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetHeadquarterOne`, params);
    },
    // 新增总部
    addHeadquarter<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddHeadquarter`, params);
    },
    //更新总部
    updateHeadquarter<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateHeadquarter`, params);
    },
    //删除总部
    deleteHeadquarter<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteHeadquarter`, params);
    },
    // 获取总部窗口
    getHeadquarterWinList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetHeadquarterWinList`, params);
    },
    // 获取总部窗口one
    getHeadquarterWinOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetHeadquarterWinOne`, params);
    },
  // 获取总部场景窗口one
  getHeadquarterSceneOne<T>(params: FormData) {
    return services.post(`${base.lk}/DigitalDict/GetHeadquarterSceneOne`, params);
  },
    // 新增总部窗口
    addHeadquarterWin<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddHeadquarterWin`, params);
    },
    //更新总部窗口
    updateHeadquarterWin<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateHeadquarterWin`, params);
    },
    //删除总部窗口
    deleteHeadquarterWin<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteHeadquarterWin`, params);
    },
    //###############获取场景组成员###################
    getSceneMemberList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetSceneMemberList`, params);
    },
    // 获取场景组成员one
    getSceneMemberOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetSceneMemberOne`, params);
    },
    // 新增场景组成员
    addSceneMember<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddSceneMember`, params);
    },
    //更新场景组成员
    updateSceneMember<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateSceneMember`, params);
    },
    //删除总场景组成员
    deleteSceneMember<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteSceneMember`, params);
    },
    //###############获取技术组成员###################
    getTechMemberList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetTechMemberList`, params);
    },
    // 获取技术组成员one
    getTechMemberOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetTechMemberOne`, params);
    },
    // 新增技术组成员
    addTechMember<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddTechMember`, params);
    },
    //更新技术组成员
    updateTechMember<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateTechMember`, params);
    },
    //删除技术组成员
    deleteTechMember<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteTechMember`, params);
    },
    //###############获取推进办公室管理员###################
    getAdanceOfficeAdminList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetAdanceOfficeAdminList`, params);
    },
    // 获取推进办公室管理员one
    getAdanceOfficeAdminOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetAdanceOfficeAdminOne`, params);
    },
    // 新增推进办公室管理员
    addAdanceOfficeAdmin<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddAdanceOfficeAdmin`, params);
    },
    //更新推进办公室管理员
    updateAdanceOfficeAdmin<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateAdanceOfficeAdmin`, params);
    },
    //删除推进办公室管理员
    deleteAdanceOfficeAdmin<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteAdanceOfficeAdmin`, params);
    },
    // Skill super-administrator configuration (system administrators only).
    getSkillSuperAdminList(params: string) {
        return services.post(`${base.lk}/DigitalDict/GetSkillSuperAdminList`, params);
    },
    addSkillSuperAdmin(params: string) {
        return services.post(`${base.lk}/DigitalDict/AddSkillSuperAdmin`, params);
    },
    updateSkillSuperAdmin(params: string) {
        return services.post(`${base.lk}/DigitalDict/UpdateSkillSuperAdmin`, params);
    },
    deleteSkillSuperAdmin(params: string) {
        return services.post(`${base.lk}/DigitalDict/DeleteSkillSuperAdmin`, params);
    },
    //###############安全审核员###################
    getSecurityReviewerList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetSecurityReviewerList`, params);
    },
    addSecurityReviewer<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddSecurityReviewer`, params);
    },
    updateSecurityReviewer<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateSecurityReviewer`, params);
    },
    deleteSecurityReviewer<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteSecurityReviewer`, params);
    },
    //###############数字员工类型###################
    getDigitalMemberTypeList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetDigitalMemberTypeList`, params);
    },
    // 获取数字员工类型one
    getDigitalMemberTypeOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetDigitalMemberTypeOne`, params);
    },
    // 新增数字员工类型
    addDigitalMemberType<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddDigitalMemberType`, params);
    },
    //更新数字员工类型
    updateDigitalMemberType<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateDigitalMemberType`, params);
    },
    //删除数字员工类型
    deleteDigitalMemberType<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteDigitalMemberType`, params);
    },
    //###############部署平台###################
    getDeployPlatformList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetDeployPlatformList`, params);
    },
    // 获取部署平台one
    getDeployPlatformOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetDeployPlatformOne`, params);
    },
    // 新增部署平台
    addDeployPlatform<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddDeployPlatform`, params);
    },
    //更新部署平台
    updateDeployPlatform<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateDeployPlatform`, params);
    },
    //删除部署平台
    deleteDeployPlatform<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteDeployPlatform`, params);
    },
    //###############年度目标###################
    getYearGoalsList<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetYearGoalsList`, params);
    },
    // 获取部署平台one
    getYearGoalsOne<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/GetYearGoalsOne`, params);
    },
    // 新增部署平台
    addYearGoals<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/AddYearGoals`, params);
    },
    //更新部署平台
    updateYearGoals<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/UpdateYearGoals`, params);
    },
    //删除部署平台
    deleteYearGoals<T>(params: FormData) {
        return services.post(`${base.lk}/DigitalDict/DeleteYearGoals`, params);
    },
};

export default digitalDictManageAPI;
